import {
    ArrayValueComponent,
    DisabledMetadataComponent,
    ItemsMetadataComponent,
    ValidationComponent,
    ValueComponent
} from '~/utils/form-validation';

type SimpleField = ValueComponent;
type SimpleValidatedField = ValueComponent & ValidationComponent;
type SimpleValidatedDisabledField = ValueComponent & ValidationComponent & DisabledMetadataComponent;
type MultiselectValidatedDisabledField =
    ValueComponent
    & ValidationComponent
    & ItemsMetadataComponent
    & DisabledMetadataComponent;
type ArrayValidatedDisabledField = ArrayValueComponent & ValidationComponent & DisabledMetadataComponent;

export interface CreateIybrFormModel {
    projectGlobalId: ArrayValidatedDisabledField;
    projectName: SimpleValidatedDisabledField;
    country: MultiselectValidatedDisabledField;
    technology: MultiselectValidatedDisabledField;
    groupName: MultiselectValidatedDisabledField;
    plant: MultiselectValidatedDisabledField;
    unit: MultiselectValidatedDisabledField;
    mainFlag: MultiselectValidatedDisabledField;
    wbsElement: SimpleValidatedDisabledField;
    aeroClassification: MultiselectValidatedDisabledField;
    maintenanceType: MultiselectValidatedDisabledField;
    primaryDepartment: MultiselectValidatedDisabledField;
    outageType: MultiselectValidatedDisabledField;
    outageIds: SimpleValidatedDisabledField;
    procurementCategory: MultiselectValidatedDisabledField;
    projectStartDate: SimpleValidatedDisabledField;
    projectEndDate: SimpleValidatedDisabledField;
    inYearProjectStartDate: SimpleValidatedField;
    inYearProjectEndDate: SimpleValidatedField;
    riskId: ArrayValidatedDisabledField;
    dateForDecision: SimpleValidatedDisabledField;
    pcClassification: MultiselectValidatedDisabledField;
    uniperShare: SimpleValidatedDisabledField;
    compensation: MultiselectValidatedDisabledField;
    isFullyCompensated: MultiselectValidatedDisabledField;
    compensationComment: SimpleValidatedDisabledField;
    requestType: MultiselectValidatedDisabledField;
    summary: SimpleValidatedDisabledField;
    year: SimpleField;
    status: SimpleField;
    furtherFinancialParameters: SimpleValidatedDisabledField;
    procurementInvolvment: SimpleValidatedDisabledField;
    projectAnchoring: SimpleValidatedDisabledField;
    projectSetup: SimpleValidatedDisabledField;
    riskAndOpportunities: SimpleValidatedDisabledField;
    projectType: MultiselectValidatedDisabledField;
    id: SimpleField;
    miniFinancialDecisionId: SimpleField;
    miniFdType: MultiselectValidatedDisabledField;
}

export interface CreateIybrFormCostModel {
    spentYearMinus1: SimpleField & ValidationComponent;
    spentYear: SimpleField & ValidationComponent;
    spentYearPlus1: SimpleField & ValidationComponent;
    spentYearPlus2: SimpleField & ValidationComponent;
    spentYearPlus3: SimpleField & ValidationComponent;
    spentAfterYear: SimpleField & ValidationComponent;
}

export interface CreateIybrFormCompensationModel {
    [key: string]: BudgetCompensationEntryModel;
}

export interface BudgetCompensationEntryModel {
    budgetRequestId: SimpleField;
    projectGlobalId: SimpleField;
    justification: SimpleValidatedField;
    yearPlus1: SimpleValidatedField;
    newYearPlus1: SimpleField;
    yearPlus2: SimpleValidatedField;
    newYearPlus2: SimpleField;
    yearPlus3: SimpleValidatedField;
    newYearPlus3: SimpleField;
    selectedMtpYear: SimpleField;
    originalYearPlus1: SimpleField;
    originalYearPlus2: SimpleField;
    originalYearPlus3: SimpleField;
}

export interface CompensationRequiredTotals {
    mtpPlus1Required: number;
    mtpPlus2Required: number;
    mtpPlus3Required: number;
}
